import React from 'react';
import './Preloader.css';
import logo from '../assets/logo.png';

function Preloader() {
  return (
    <section className="phone-screen preloader-screen" aria-label="Loading exhibition app">
      <div className="preloader-grid" aria-hidden="true" />
      <div className="preloader-noise" aria-hidden="true" />

      <div className="preloader-orbit" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>

      <div className="preloader-brand">
        <img src={logo} alt="Exhibition logo" />
        <p>Egypt International Exhibition</p>
        <h1>Textile Future 26</h1>
      </div>

      <div className="preloader-progress" aria-hidden="true">
        <span />
      </div>

      <div className="preloader-ticker" aria-hidden="true">
        <div>
          <span>Preparing ticket</span>
          <span>Loading halls</span>
          <span>Syncing schedule</span>
          <span>Opening Cairo 2026</span>
        </div>
      </div>
    </section>
  );
}

export default Preloader;
